import { UWBlockingPoint } from '@xengage/gw-portals-edge-validation-js';

const BLOCKS_QUOTES = [UWBlockingPoint.BLOCKS_QUOTE, UWBlockingPoint.BLOCKS_QUOTE_RELEASE];
const blockingPointsToExclude = [UWBlockingPoint.NON_BLOCKING, UWBlockingPoint.BLOCKS_ISSUANCE, UWBlockingPoint.BLOCKS_BIND];

function isQuoteBlocked(underwritingIssues) {
    return underwritingIssues ? underwritingIssues.some((uwIssue) => uwIssue.currentBlockingPoint !== UWBlockingPoint.NON_BLOCKING):false;
};

function findBlockingPoint(underwritingIssues) {
    return underwritingIssues ? underwritingIssues.some((issue) => { return BLOCKS_QUOTES.includes(issue.currentBlockingPoint);}): false; 
};

function isQuoteBlockedForPolicyChange(underwritingIssues) {
    return underwritingIssues ? underwritingIssues.some((uwIssue) => !blockingPointsToExclude.includes(uwIssue.currentBlockingPoint)) :false;
};

export default {
    isQuoteBlocked,
    findBlockingPoint,
    isQuoteBlockedForPolicyChange
};